module.exports = __webpack_public_path__ + "media/application/images/2021/consumer-white-a889c6f2f20768525f399bd3be0c2458.svg";